
// 导入头像图片
import avatarImg from '../icon/avatar.jpg';
let ArticleList = [
    {
        id: 1,
        title: '测试文章1的标题',
        summary: '测试文章1的简介',
        content: '# 测试文章1的内容',
        author: 'Breamit',
        createTime: '2024/12/19 13:35',
        updateTime: '2024/12/19 13:35',
        isPublished: true,
    },
    {
        id: 2,
        title: 'JavaScript基础语法详解',
        summary: '深入学习JavaScript的基础语法知识',
        content: 'JavaScript是一种广泛用于前端开发的脚本语言，本文将详细介绍其基础语法结构和使用方法。',
        author: 'Breamit',
        createTime: '2021/12/18 10:30',
        updateTime: '2021/12/18 10:30',
        isPublished: true,
    },
    {
        id: 3,
        title: 'React Hooks使用指南',
        summary: '全面掌握React Hooks的使用技巧',
        content: 'React Hooks是React 16.8版本引入的新特性，它允许你在不编写class的情况下使用state以及其他的React特性。',
        author: 'Breamit',
        createTime: '2025/12/17 14:22',
        updateTime: '2025/12/17 14:22',
        isPublished: true,
    },
    {
        id:4,
        title: 'Flutter有状态组件',
        sumary: 'Flutter中关于有状态组件的详细介绍',
        content: '### 有状态组件\n\n\n - 有状态组件一般指的是样式需要更改的组件，比如说输入框，按钮，下拉框等等\n\n\n - 有状态组件的制作较为复杂，首先需要定义一个外部类，用来展示样式，还需要定义一个内部类，用来存储数据，更改样式结构，类似于视图模型结构\n\n\n - 外部类需要继承于StatefulWidget，内部类需要继承于State<外部类名称>\n\n\n - 外部类需要重写createState方法，内部类需要重写build方法\n\n\n - 当有状态组件被创建的时候，流程如下：\n 1.StatefulWidget被创建\n 2.执行createState方法，创建内部类对象\n 3.执行内部类对象中的initState方法\n 4.执行didChangeDependencies方法\n 5.执行build方法，返回一个Widget\n\n\n - 更新阶段：\n 1.父组件重组\n 2.执行didUpdateWidget方法\n\n\n - 销毁阶段：\n\n\n 1.组件被移除\n 2.执行deactivate方法\n 3.执行dispose方法\n\n\n ```dart\n import \'package:flutter/material.dart\';\n\n\n class FirstPage extends StatefulWidget {\n   const FirstPage({ Key? key }) : super(key: key);\n   @override\n   State<StatefulWidget> createState() {\n     return _FirstPageState();\n   }\n }\n\n\n class _FirstPageState extends State<FirstPage> {\n   int _count = 0;\n   @override\n   Widget build(BuildContext context) {\n     return MaterialApp(\n       title: "first page",\n       home: Scaffold(\n         appBar: AppBar(\n           title: Text(\n             "app bar",\n             ),\n           backgroundColor: Colors.yellow,\n         ),\n         body: Center(\n           child: Row(\n             mainAxisAlignment: MainAxisAlignment.spaceEvenly,\n             children: [\n               TextButton(\n                 onPressed: () {\n                   setState(() => _count--);\n                 },\n                 style: TextButton.styleFrom(\n                   padding: EdgeInsets.all(10),\n                   shape: RoundedRectangleBorder(\n                     borderRadius: BorderRadius.circular(10)\n                   ),\n                   backgroundColor: Colors.blue\n                 ),\n                 child: Text(\n                   "click me to sub count",\n                   style: TextStyle(\n                     color: Colors.white,\n                     fontSize: 15,\n                   )\n                 ),\n               ),\n               Text(\n                 "$_count",\n                 \n                 style: TextStyle(\n                   color: Colors.black,\n                   fontSize: 20\n                 )\n               ),\n               TextButton(\n                 onPressed: () => setState(() => _count++),\n                 style: TextButton.styleFrom(\n                   padding: EdgeInsets.all(10),\n                   shape: RoundedRectangleBorder(\n                     borderRadius: BorderRadius.circular(10)\n                   ),\n                   backgroundColor: Colors.blue\n                 ),\n                 child: Text(\n                   "click me to add count",\n                   style: TextStyle(\n                     color: Colors.white,\n                     fontSize: 15,\n                   )\n                 ),\n               )\n             ],\n           )\n         )\n       )\n     );\n   }\n }\n ```',
        author: 'Breamit',
        createTime: '2025/12/17 14:22',
        updateTime: '2025/12/17 14:22',
        isPublished: true,
    }
    
]

function getArticleById(id) {
    return ArticleList.find(article => article.id === id);
}

function addArticle(
    title,
    summary,
    content,
    author,
    createTime,
    updateTime,
    isPublished
) {
    const newArticle = {
        id: ArticleList.length + 1,
        title,
        summary,
        content,
        author,
        createTime,
        updateTime,
        isPublished,
    };
    // 参数校验
    if (!title || !summary || !content || !author || !createTime || !updateTime || !isPublished) {
        throw new Error('参数错误');
    }

    // 添加文章，避免爆内存了
    try{
        ArticleList.push(newArticle);
    } catch (error) {
        throw new Error('添加文章失败');
    }
    
}

function getArticleListLength() {
    return ArticleList.length;
}

export { addArticle, getArticleById, getArticleListLength,ArticleList};

//----------------------- 文章信息 Article Infomation --------------------------
//----------------------- 用户信息 User Infomation --------------------------

//用户对象
class UserInfo {
    constructor(name,   //required
        password = "",  //required
        avatar = "",    
        introcution  = "无",
        details = "这个人很懒，什么都没写",
        email = "无",
        techStack = [],
        interest = "无",
        github = "#",
        
    ) {
        this.name = name;
        this.avatar = avatar;
        this.introcution = introcution;
        this.details = details;
        this.email = email;
        this.techStack = techStack;
        this.interest = interest;
        this.github = github;
        this.password = password;

    }

    getName() {return this.name;}
    getAvatar() {return this.avatar;}
    getIntrocution() {return this.introcution;}
    getDetails() {return this.details;}
    getEmail() {return this.email;}
    getTechStack() {return this.techStack;}
    getInterest() {return this.interest;}
    getGithub() {return this.github;}
    getPassword() {return this.password;}

    setName(name) {this.name = name;}
    setAvatar(avatar) {this.avatar = avatar;}
    setIntrocution(introcution) {this.introcution = introcution;}
    setDetails(details) {this.details = details;}
    setEmail(email) {this.email = email;}
    setTechStack(techStack) {this.techStack = techStack;}
    setInterest(interest) {this.interest = interest;}
    setGithub(github) {this.github = github;}
    setPassword(password) {this.password = password;}


}

// constructor(name,   //required
//         password = "",  //required
//         avatar = "",    
//         introcution  = "无",
//         details = "这个人很懒，什么都没写",
//         email = "无",
//         techStack = [],
//         interest = "无",
//         github = "#",
        
//     ) 
let UserInfoList = [
    new UserInfo("Breamit",
        "123456789",
        avatarImg,
        "嘻嘻",
        "这个人很懒，什么也没写",
        "202431116020273@stu.hubu.edu.cn",
        ["Qt","Flutter","React","MySQL","Java","Django"],
        "只想要躺平，然后玩玩游戏",
        "#"
    ),
    new UserInfo("Tourist",
        "123456789",
        null,
        "请先登录",
        "这个人很懒，什么也没写",
        "无",
        [],
        "请先登录",
        "#"
    ),
];

function getUserInfoByName(name) {
    return UserInfoList.find(userInfo => userInfo.getName() === name);
}

function getAuthInfo() {
   return UserInfoList.find(userInfo => userInfo.getName() === 'Breamit');
}
function addUserInfo(
    name,
    password,
    avatar,
    introcution,
    details,
    email,
    techStack,
    interest,
    github
) { 
    if (UserInfoList.find(userInfo => userInfo.getName() === name)){
        return false;
    } else {
        const newUserInfo = new UserInfo(
            name,
            password,
            avatar,
            introcution,
            details,
            email,
            techStack,
            interest,
            github
        );
        UserInfoList.push(newUserInfo);
        return true;
    }
}

let currentUserInfo = getUserInfoByName("Tourist");

function setCurrentUserInfo(userInfo) {
    currentUserInfo = userInfo;
}

function getCurrentUserInfo() {
    return currentUserInfo;
}

export { UserInfoList,
        UserInfo,
     getUserInfoByName, 
     addUserInfo,
     getAuthInfo,
     setCurrentUserInfo, 
     getCurrentUserInfo};